import { EMAIL_TYPE, DEFAULT_SENDER_EMAIL } from '@Constants/emailConstant';
import { RECEIVER_TYPE } from '@Constants/receiverConstant';

import * as actionTypes from './actionTypes';
import * as API from './api';

export const setIsOnline = (isOnline) => ({
  type: actionTypes.SET_IS_ONLINE,
  isOnline,
});

// 設定當前頁面的 inner width
export const setWindowInnerWidth = (width) => ({
  type: actionTypes.SET_WINDOW_INNER_WIDTH,
  width,
});

// 是否第一次使用(藉由啟動碼有無最後使用時間判定)
export const getIsDoneFirstTimeAction = {
  getIsDoneFirstTime: () => {
    return (dispatch) => {
      dispatch(getIsDoneFirstTimeAction.getIsDoneFirstTImePending());
      API.getIsDoneFirstTime()
        .then((res) => dispatch(getIsDoneFirstTimeAction.getIsDoneFirstTimeFulfiled(res)))
        .catch((error) => dispatch(getIsDoneFirstTimeAction.getIsDoneFirstTimeFailure(error)));
    };
  },
  getIsDoneFirstTImePending: () => ({
    type: actionTypes.GET_IS_DONE_FIRST_TIME_PENDING,
  }),
  getIsDoneFirstTimeFulfiled: (data) => ({
    type: actionTypes.GET_IS_DONE_FIRST_TIME_FULFILLED,
    data,
  }),
  getIsDoneFirstTimeFailure: (error) => ({
    type: actionTypes.GET_IS_DONE_FIRST_TIME_FAILURE,
    error,
  }),
};
export const setIsDoneFirstTime = (isDone) => ({
  type: actionTypes.IS_DONE_FIRST_TIME,
  isDone,
});

// 切換 導覽 active key
export const postTutorialsActiveKey = (key) => ({
  type: actionTypes.POST_TUTORIALS_ACTIVE_KEY,
  key,
});

export const setIsShowPriorSettingBlock = () => ({
  type: actionTypes.SET_IS_SHOW_PRIOR_SETTING_BLOCK,
});

export const setListNoticeShow = (key) => ({
  type: actionTypes.SET_LIST_NOTICE_SHOW,
  key,
});

export const setIsOpenedSmsEditInstructionPanel = (isOpened) => ({
  type: actionTypes.SET_IS_OPENED_SMS_EDIT_INSTRUCTION_PANEL,
  isOpened,
});

// left-top hint
export const setIsHideRightBottomHint = (isHidden) => ({
  type: actionTypes.SET_IS_HIDDEN_RIGHT_BOTTOM_HINT,
  isHidden,
});

export const setIsHiddenEmailTemplateHint = (isHidden) => ({
  type: actionTypes.SET_IS_HIDDEN_EMAIL_TEMPLATE_HINT,
  isHidden,
});

export const setIsHiddenHealthFormHint = (isHidden) => ({
  type: actionTypes.SET_IS_HIDDEN_HEALTH_FORM_HINT,
  isHidden,
});

export const setIsHiddenTutorialTabHint = (isHidden) => ({
  type: actionTypes.SET_IS_HIDDEN_TUTORIAL_TAB_HINT,
  isHidden,
});

// 名單 Email 格式檢查
export const setIsEmailFormatChecked = (isChecked) => ({
  type: actionTypes.SET_IS_EMAIL_FORMAT_CHECKED,
  isChecked,
});

// 名單 phone 格式檢查
export const setIsCellPhoneFormatChecked = (isChecked) => ({
  type: actionTypes.SET_IS_CELL_PHONE_FORMAT_CHECKED,
  isChecked,
});

// 是否第一次造訪平台
export const setIsVisitFirstTime = (isFirstTime) => ({
  type: actionTypes.SET_IS_VISIT_FIRST_TIME,
  isFirstTime,
});

// 不顯示標籤租用資訊 toast
export const setIsNotBadgeLabelMachineRentInformationShown = (isChecked) => ({
  type: actionTypes.SET_IS_NOT_BADGE_LABEL_MACHINE_RENT_INFORMATION_SHOWN,
  isChecked,
});

// 初始化所有 state
export const initializeAllStates = () => ({
  type: actionTypes.INITIALIZE_ALL_STATES,
});

// 初始化選定的 state
export const initializeStates = () => ({
  type: actionTypes.INITIALIZE_STATES_FULFILLED,
});

// SET LANGUAGE
export const setUserLanguage = (language) => ({
  type: actionTypes.SET_USER_LANGUAGE,
  data: language,
});

// 成功登入後，設定使用者 token
export const setUserAuthenticated = (token) => ({
  type: actionTypes.SET_USER_AUTHENTICATED,
  token,
});

export const setUserRoles = (roles) => ({
  type: actionTypes.SET_USER_ROLES,
  roles,
});

// 是否有其它裝置登入
export const setIsLoggedIn = (isLoggedIn) => ({
  type: actionTypes.SET_IS_LOGGED_IN,
  isLoggedIn,
});

export const logout = () => ({
  type: actionTypes.LOGOUT,
});

// 設定目前選擇的 Event
export const switchEvent = (eventInfo = {}) => ({
  type: actionTypes.SWITCH_EVENT,
  data: eventInfo,
});

// ------ 頁面尚未儲存的提示阻擋 ----------
// survey form edit
export const setIsSurveyFormEditSavedNotYet = (toggle) => ({
  type: actionTypes.SET_IS_SURVEY_FORM_EDIT_SAVED_NOT_YET,
  toggle,
});

// index page edit
export const setIsIndexPageEditSavedNotYet = (toggle) => ({
  type: actionTypes.SET_IS_INDEX_PAGE_EDIT_SAVED_NOT_YET,
  toggle,
});

// badge edit
export const setIsBadgeEditSavedNotYet = (toggle) => ({
  type: actionTypes.SET_IS_BADGE_EDIT_SAVED_NOT_YET,
  toggle,
});

// -------系統相關 --------------

// 設定 server timestamp
export const setSystemTimestamp = (timestamp) => ({
  type: actionTypes.SET_SYSTEM_TIMESTAMP,
  timestamp,
});

// 信箱驗證
export const postRegisterAuthenticatedPending = () => ({
  type: actionTypes.POST_REGISTER_AUTHENTICATED_PENDING,
});

export const postRegisterAuthenticatedSuccess = (data) => ({
  type: actionTypes.POST_REGISTER_AUTHENTICATED_FULFILLED,
  data,
});

export const postRegisterAuthenticatedFailure = (error) => ({
  type: actionTypes.POST_REGISTER_AUTHENTICATED_FAILURE,
  error,
});

export const postRegisterAuthenticated = (token) => {
  return (dispatch) => {
    dispatch(postRegisterAuthenticatedPending());
    API.postRegisterAuthenticated(token)
      .then((res) => dispatch(postRegisterAuthenticatedSuccess(res)))
      .catch((error) => dispatch(postRegisterAuthenticatedFailure(error)));
  };
};

// 重發驗證信
export const reSendRegisterAuthenticatedPending = () => ({
  type: actionTypes.RESEND_REGISTER_AUTHENTICATED_PENDING,
});

export const reSendRegisterAuthenticatedSuccess = (data) => ({
  type: actionTypes.RESEND_REGISTER_AUTHENTICATED_FULFILLED,
  data,
});

export const reSendRegisterAuthenticatedFailure = (error) => ({
  type: actionTypes.RESEND_REGISTER_AUTHENTICATED_FAILURE,
  error,
});

export const reSendRegisterAuthenticated = (account) => {
  return (dispatch) => {
    dispatch(reSendRegisterAuthenticatedPending());
    API.reSendRegisterAuthenticated(account)
      .then((res) => dispatch(reSendRegisterAuthenticatedSuccess(res)))
      .catch((error) => dispatch(reSendRegisterAuthenticatedFailure(error)));
  };
};

// 註冊
export const postRegisterPending = () => ({
  type: actionTypes.POST_REGISTER_PENDING,
});
export const postRegisterSuccess = (data) => ({
  type: actionTypes.POST_REGISTER_FULFILLED,
  data,
});
export const postRegisterFailure = (error) => ({
  type: actionTypes.POST_REGISTER_FAILURE,
  error,
});

export const postRegister = (
  account,
  password,
  name,
  company,
  cellPhone,
  taxIDNumber,
  industry,
) => {
  return (dispatch) => {
    dispatch(postRegisterPending());
    API.postRegister(account, password, name, company, cellPhone, taxIDNumber, industry)
      .then((res) => dispatch(postRegisterSuccess(res.data)))
      .catch((error) => dispatch(postRegisterFailure(error)));
  };
};

// 註冊時，檢查帳號可否使用
export const checkRepeatAccountPending = () => ({
  type: actionTypes.CHECK_REPEAT_ACCOUNT_PENDING,
});

export const checkRepeatAccountSuccess = (data) => ({
  type: actionTypes.CHECK_REPEAT_ACCOUNT_FULFILLED,
  data,
});

export const checkRepeatAccountFailure = (error) => ({
  type: actionTypes.CHECK_REPEAT_ACCOUNT_FAILURE,
  error,
});

export const checkRepeatAccount = (account) => {
  return (dispatch) => {
    dispatch(checkRepeatAccountPending());
    API.checkRepeatAccount(account)
      .then((res) => dispatch(checkRepeatAccountSuccess(res.data)))
      .catch((error) => dispatch(checkRepeatAccountFailure(error)));
  };
};

// 檢查登入
export const checkLoginPending = () => ({
  type: actionTypes.CHECK_LOGIN_PENDING,
});

export const checkLoginSuccess = (data) => ({
  type: actionTypes.CHECK_LOGIN_FULFILLED,
  data,
});

export const checkLoginFailure = (error) => ({
  type: actionTypes.CHECK_LOGIN_FAILURE,
  error,
});

export const checkLogin = (account, password) => {
  return (dispatch) => {
    dispatch(checkLoginPending());
    API.checkLogin(account, password)
      .then((res) => dispatch(checkLoginSuccess(res)))
      .catch((error) => dispatch(checkLoginFailure(error)));
  };
};

// 檢查 token 是否過期
export const checkTokenExpiredAction = {
  checkTokenExpired: () => {
    return (dispatch) => {
      dispatch(checkTokenExpiredAction.checkTokenExpiredPending());
      API.checkTokenExpired()
        .then((res) => dispatch(checkTokenExpiredAction.checkTokenExpiredFulfilled(res)))
        .catch((error) => dispatch(checkTokenExpiredAction.checkTokenExpiredFailed(error)));
    };
  },

  checkTokenExpiredPending: () => ({
    type: actionTypes.CHECK_TOKEN_EXPIRED_PENDING,
  }),
  checkTokenExpiredFulfilled: (data) => ({
    type: actionTypes.CHECK_TOKEN_EXPIRED_FULFILLED,
    data,
  }),
  checkTokenExpiredFailed: (error) => ({
    type: actionTypes.CHECK_TOKEN_EXPIRED_FAILURE,
    error,
  }),
};

// 忘記密碼發送重設密碼信件
export const sendForgotPasswordEmailPending = () => ({
  type: actionTypes.SEND_FORGOT_PASSWORD_EMAIL_PENDING,
});

export const sendForgotPasswordEmailSuccess = (data) => ({
  type: actionTypes.SEND_FORGOT_PASSWORD_EMAIL_FULFILLED,
  data,
});

export const sendForgotPasswordEmailFailure = (error) => ({
  type: actionTypes.SEND_FORGOT_PASSWORD_EMAIL_FAILURE,
  error,
});

export const sendForgotPasswordEmail = (account) => {
  return (dispatch) => {
    dispatch(sendForgotPasswordEmailPending());
    API.sendForgotPasswordEmail(account)
      .then((res) => dispatch(sendForgotPasswordEmailSuccess(res)))
      .catch((error) => dispatch(sendForgotPasswordEmailFailure(error)));
  };
};

// 重設密碼
export const resetNewPasswordPending = () => ({
  type: actionTypes.RESET_NEW_PASSWORD_PENDING,
});

export const resetNewPasswordSuccess = (data) => ({
  type: actionTypes.RESET_NEW_PASSWORD_FULFILLED,
  data,
});

export const resetNewPasswordFailure = (error) => ({
  type: actionTypes.RESET_NEW_PASSWORD_FAILURE,
  error,
});

export const resetNewPassword = (token, password) => {
  return (dispatch) => {
    dispatch(resetNewPasswordPending());
    API.resetNewPassword(token, password)
      .then((res) => dispatch(resetNewPasswordSuccess(res)))
      .catch((error) => dispatch(resetNewPasswordFailure(error)));
  };
};

// ------------- device code -----------------
// 取得啟動碼 list
export const getDeviceCodeListAction = {
  getDeviceCodeList: (projectCode) => {
    return (dispatch) => {
      dispatch(getDeviceCodeListAction.getDeviceCodeListPending());
      API.getDeviceCodeList(projectCode)
        .then((res) => dispatch(getDeviceCodeListAction.getDeviceCodeListFulfilled(res)))
        .catch((error) => dispatch(getDeviceCodeListAction.getDeviceCodeListFailed(error)));
    };
  },
  getDeviceCodeListPending: () => ({
    type: actionTypes.GET_DEVICE_CODE_LIST_PENDING,
  }),
  getDeviceCodeListFulfilled: (data) => ({
    type: actionTypes.GET_DEVICE_CODE_LIST_FULFILLED,
    data,
  }),
  getDeviceCodeListFailed: (error) => ({
    type: actionTypes.GET_DEVICE_CODE_LIST_FAILURE,
    error,
  }),
};

// logout device code
export const getDisuseDeviceCodePending = () => ({
  type: actionTypes.GET_DISUSE_DEVICE_CODE_PENDING,
});
export const getDisuseDeviceCodeFulfilled = (data) => ({
  type: actionTypes.GET_DISUSE_DEVICE_CODE_FULFILLED,
  data,
});
export const getDisuseDeviceCodeFailure = (error) => ({
  type: actionTypes.GET_DISUSE_DEVICE_CODE_FAILURE,
  error,
});
export const getDisuseDeviceCode = (projectCode, deviceSeq) => {
  return (dispatch) => {
    dispatch(getDisuseDeviceCodePending());
    API.getDisuseDeviceCode(projectCode, deviceSeq)
      .then((res) => dispatch(getDisuseDeviceCodeFulfilled(res)))
      .catch((error) => dispatch(getDisuseDeviceCodeFailure(error)));
  };
};

// create a new device code
export const postCreateDeviceCodePending = () => ({
  type: actionTypes.POST_CREATE_DEVICE_CODE_PENDING,
});
export const postCreateDeviceCodeFulfilled = (data) => ({
  type: actionTypes.POST_CREATE_DEVICE_CODE_FULFILLED,
  data,
});
export const postCreateDeviceCodeFailure = (error) => ({
  type: actionTypes.POST_CREATE_DEVICE_CODE_FAILURE,
  error,
});
export const postCreateDeviceCode = (projectCode) => {
  return (dispatch) => {
    dispatch(postCreateDeviceCodePending());
    API.postCreateDeviceCode(projectCode)
      .then((res) => dispatch(postCreateDeviceCodeFulfilled(res)))
      .catch((error) => dispatch(postCreateDeviceCodeFailure(error)));
  };
};

// delete a device code
export const deleteDeviceCodePending = () => ({
  type: actionTypes.DELETE_DEVICE_CODE_PENDING,
});
export const deleteDeviceCodeFulfilled = (data) => ({
  type: actionTypes.DELETE_DEVICE_CODE_FULFILLED,
  data,
});
export const deleteDeviceCodeFailure = (error) => ({
  type: actionTypes.DELETE_DEVICE_CODE_FAILURE,
  error,
});
export const deleteDeviceCode = (projectCode, deviceSeq) => {
  return (dispatch) => {
    dispatch(deleteDeviceCodePending());
    API.deleteDeviceCode(projectCode, deviceSeq)
      .then((res) => dispatch(deleteDeviceCodeFulfilled(res)))
      .catch((error) => dispatch(deleteDeviceCodeFailure(error)));
  };
};

// rename device code
export const updateDeviceCodeNamePending = () => ({
  type: actionTypes.UPDATE_DEVICE_CODE_NAME_PENDING,
});

export const updateDeviceCodeNameFulfilled = (data) => ({
  type: actionTypes.UPDATE_DEVICE_CODE_NAME_FULFILLED,
  data,
});

export const updateDeviceCodeNameFailure = (error) => ({
  type: actionTypes.UPDATE_DEVICE_CODE_NAME_FAILURE,
  error,
});

export const updateDeviceCodeName = (projectCode, deviceSeq, name) => {
  return (dispatch) => {
    dispatch(updateDeviceCodeNamePending());
    API.renameDeviceCode(projectCode, deviceSeq, name)
      .then((res) => dispatch(updateDeviceCodeNameFulfilled(res)))
      .catch((error) => dispatch(updateDeviceCodeNameFailure(error)));
  };
};

// ------------- booth device code -----------------
// 取得攤位啟動碼 list
export const getBoothDeviceCodeListAction = {
  getBoothDeviceCodeList: (projectCode, deviceSeq) => {
    return (dispatch) => {
      dispatch(getBoothDeviceCodeListAction.getBoothDeviceCodeListPending());
      API.getBoothDeviceCodeList(projectCode, deviceSeq)
        .then((res) => dispatch(getBoothDeviceCodeListAction.getBoothDeviceCodeListFulfilled(res)))
        .catch((error) =>
          dispatch(getBoothDeviceCodeListAction.getBoothDeviceCodeListFailed(error)),
        );
    };
  },
  getBoothDeviceCodeListPending: () => ({
    type: actionTypes.GET_BOOTH_DEVICE_CODE_LIST_PENDING,
  }),
  getBoothDeviceCodeListFulfilled: (data) => ({
    type: actionTypes.GET_BOOTH_DEVICE_CODE_LIST_FULFILLED,
    data,
  }),
  getBoothDeviceCodeListFailed: (error) => ({
    type: actionTypes.GET_BOOTH_DEVICE_CODE_LIST_FAILURE,
    error,
  }),
};

// logout booth device code
export const getDisuseBoothDeviceCodePending = () => ({
  type: actionTypes.GET_DISUSE_BOOTH_DEVICE_CODE_PENDING,
});
export const getDisuseBoothDeviceCodeFulfilled = (data) => ({
  type: actionTypes.GET_DISUSE_BOOTH_DEVICE_CODE_FULFILLED,
  data,
});
export const getDisuseBoothDeviceCodeFailure = (error) => ({
  type: actionTypes.GET_DISUSE_BOOTH_DEVICE_CODE_FAILURE,
  error,
});
export const getDisuseBoothDeviceCode = (projectCode, deviceSeq) => {
  return (dispatch) => {
    dispatch(getDisuseBoothDeviceCodePending());
    API.getDisuseBoothDeviceCode(projectCode, deviceSeq)
      .then((res) => dispatch(getDisuseBoothDeviceCodeFulfilled(res)))
      .catch((error) => dispatch(getDisuseBoothDeviceCodeFailure(error)));
  };
};

// create a new booth device code
export const postCreateBoothDeviceCodePending = () => ({
  type: actionTypes.POST_CREATE_BOOTH_DEVICE_CODE_PENDING,
});
export const postCreateBoothDeviceCodeFulfilled = (data) => ({
  type: actionTypes.POST_CREATE_BOOTH_DEVICE_CODE_FULFILLED,
  data,
});
export const postCreateBoothDeviceCodeFailure = (error) => ({
  type: actionTypes.POST_CREATE_BOOTH_DEVICE_CODE_FAILURE,
  error,
});
export const postCreateBoothDeviceCode = (projectCode) => {
  return (dispatch) => {
    dispatch(postCreateBoothDeviceCodePending());
    API.postCreateBoothDeviceCode(projectCode)
      .then((res) => dispatch(postCreateBoothDeviceCodeFulfilled(res)))
      .catch((error) => dispatch(postCreateBoothDeviceCodeFailure(error)));
  };
};

// delete a booth device code
export const deleteBoothDeviceCodePending = () => ({
  type: actionTypes.DELETE_BOOTH_DEVICE_CODE_PENDING,
});
export const deleteBoothDeviceCodeFulfilled = (data) => ({
  type: actionTypes.DELETE_BOOTH_DEVICE_CODE_FULFILLED,
  data,
});
export const deleteBoothDeviceCodeFailure = (error) => ({
  type: actionTypes.DELETE_BOOTH_DEVICE_CODE_FAILURE,
  error,
});
export const deleteBoothDeviceCode = (projectCode, deviceSeq) => {
  return (dispatch) => {
    dispatch(deleteBoothDeviceCodePending());
    API.deleteBoothDeviceCode(projectCode, deviceSeq)
      .then((res) => dispatch(deleteBoothDeviceCodeFulfilled(res)))
      .catch((error) => dispatch(deleteBoothDeviceCodeFailure(error)));
  };
};

// rename booth device code
export const updateBoothDeviceCodeNamePending = () => ({
  type: actionTypes.UPDATE_BOOTH_DEVICE_CODE_NAME_PENDING,
});

export const updateBoothDeviceCodeNameFulfilled = (data) => ({
  type: actionTypes.UPDATE_BOOTH_DEVICE_CODE_NAME_FULFILLED,
  data,
});

export const updateBoothDeviceCodeNameFailure = (error) => ({
  type: actionTypes.UPDATE_BOOTH_DEVICE_CODE_NAME_FAILURE,
  error,
});

export const updateBoothDeviceCodeName = (projectCode, deviceSeq, name) => {
  return (dispatch) => {
    dispatch(updateBoothDeviceCodeNamePending());
    // 目前仍使用與一般啟動碼相同的API
    API.renameDeviceCode(projectCode, deviceSeq, name)
      .then((res) => dispatch(updateBoothDeviceCodeNameFulfilled(res)))
      .catch((error) => dispatch(updateBoothDeviceCodeNameFailure(error)));
  };
};

// 取得 account 資料
export const getProfileAction = {
  getProfile: () => {
    return (dispatch) => {
      dispatch(getProfileAction.getProfilePending());
      API.getProfile()
        .then((res) => dispatch(getProfileAction.getProfileFulfilled(res)))
        .catch((error) => dispatch(getProfileAction.getProfileFailure(error)));
    };
  },
  getProfilePending: () => ({
    type: actionTypes.GET_PROFILE_PENDING,
  }),
  getProfileFulfilled: (data) => ({
    type: actionTypes.GET_PROFILE_FULFILLED,
    data,
  }),
  getProfileFailure: (error) => ({
    type: actionTypes.GET_PROFILE_FAILURE,
    error,
  }),
};

// 更新 account 資料
export const updateProfileAction = {
  updateProfile: (name, company, cellPhone, taxIDNumber, language, industry) => {
    return (dispatch) => {
      dispatch(updateProfileAction.updateProfilePending());
      API.updateProfile(name, company, cellPhone, taxIDNumber, language, industry)
        .then((res) => dispatch(updateProfileAction.updateProfileFulfilled(res)))
        .catch((error) => dispatch(updateProfileAction.updateProfileFailure(error)));
    };
  },
  updateProfilePending: () => ({
    type: actionTypes.UPDATE_PROFILE_PENDING,
  }),
  updateProfileFulfilled: (data) => ({
    type: actionTypes.UPDATE_PROFILE_FULFILLED,
    data,
  }),
  updateProfileFailure: (error) => ({
    type: actionTypes.UPDATE_PROFILE_FAILURE,
    error,
  }),
};

// ------ 名單 API 相關 ------

// ---- email template --------
// get email templates
export const getEmailTemplatesAction = {
  getEmailTemplates: (tokenId) => {
    return (dispatch) => {
      dispatch(getEmailTemplatesAction.getEmailTemplatesPending());
      API.getEmailTemplates(tokenId)
        .then((res) => {
          const formatResponse = JSON.parse(JSON.stringify(res));
          let dataWithAdjustedJson = [];
          if (res !== '' && res?.status >= 200 && res.status < 300 && res?.data?.data) {
            dataWithAdjustedJson = JSON.parse(JSON.stringify(res.data.data));

            dataWithAdjustedJson.map((template) => {
              const templateData = template;
              const { json } = templateData;
              templateData.json = JSON.parse(json);
            });
            formatResponse.data.data = dataWithAdjustedJson;
            dispatch(getEmailTemplatesAction.getEmailTemplatesFulfilled(formatResponse));
          } else {
            dispatch(getEmailTemplatesAction.getEmailTemplatesFulfilled(res));
          }
        })
        .catch((error) => dispatch(getEmailTemplatesAction.getEmailTemplatesFailure(error)));
    };
  },
  getEmailTemplatesPending: () => ({
    type: actionTypes.GET_EMAIL_TEMPLATES_PENDING,
  }),
  getEmailTemplatesFulfilled: (data) => ({
    type: actionTypes.GET_EMAIL_TEMPLATES_FULFILLED,
    data,
  }),
  getEmailTemplatesFailure: (error) => ({
    type: actionTypes.GET_EMAIL_TEMPLATES_FAILURE,
    error,
  }),
};

// post email template
export const postEmailTemplateAction = {
  postEmailTemplate: (name, html, json, emailTitle) => {
    return (dispatch) => {
      dispatch(postEmailTemplateAction.postEmailTemplatePending());
      API.postEmailTemplate(name, html, json, emailTitle)
        .then((res) => dispatch(postEmailTemplateAction.postEmailTemplateFulfilled(res)))
        .catch((error) => dispatch(postEmailTemplateAction.postEmailTemplateFailure(error)));
    };
  },
  postEmailTemplatePending: () => ({
    type: actionTypes.POST_EMAIL_TEMPLATE_PENDING,
  }),
  postEmailTemplateFulfilled: (data) => ({
    type: actionTypes.POST_EMAIL_TEMPLATE_FULFILLED,
    data,
  }),
  postEmailTemplateFailure: (error) => ({
    type: actionTypes.POST_EMAIL_TEMPLATE_FAILURE,
    error,
  }),
};

// delete email template
export const deleteEmailTemplateAction = {
  deleteEmailTemplate: (templateId) => {
    return (dispatch) => {
      dispatch(deleteEmailTemplateAction.deleteEmailTemplatePending());
      API.deleteEmailTemplate(templateId)
        .then((res) => dispatch(deleteEmailTemplateAction.deleteEmailTemplateFulfilled(res)))
        .catch((error) => dispatch(deleteEmailTemplateAction.deleteEmailTemplateFailure(error)));
    };
  },
  deleteEmailTemplatePending: () => ({
    type: actionTypes.DELETE_EMAIL_TEMPLATE_PENDING,
  }),
  deleteEmailTemplateFulfilled: (data) => ({
    type: actionTypes.DELETE_EMAIL_TEMPLATE_FULFILLED,
    data,
  }),
  deleteEmailTemplateFailure: (error) => ({
    type: actionTypes.DELETE_EMAIL_TEMPLATE_FAILURE,
    error,
  }),
};

// patch email template
export const patchEmailTemplateAction = {
  patchEmailTemplate: (templateId, name, html, json, emailTitle) => {
    return (dispatch) => {
      dispatch(patchEmailTemplateAction.patchEmailTemplatePending());
      API.patchEmailTemplate(templateId, name, html, json, emailTitle)
        .then((res) => dispatch(patchEmailTemplateAction.patchEmailTemplateFulfilled(res)))
        .catch((error) => dispatch(patchEmailTemplateAction.patchEmailTemplateFailure(error)));
    };
  },
  patchEmailTemplatePending: () => ({
    type: actionTypes.PATCH_EMAIL_TEMPLATE_PENDING,
  }),
  patchEmailTemplateFulfilled: (data) => ({
    type: actionTypes.PATCH_EMAIL_TEMPLATE_FULFILLED,
    data,
  }),
  patchEmailTemplateFailure: (error) => ({
    type: actionTypes.PATCH_EMAIL_TEMPLATE_FAILURE,
    error,
  }),
};

// --- email list ----
// get email list
export const getEmailListAction = {
  getEmailList: (projectCode, seq) => {
    return (dispatch) => {
      dispatch(getEmailListAction.getEmailListPending());
      API.getEmailList(projectCode, seq)
        .then((res) => dispatch(getEmailListAction.getEmailListFulfilled(res)))
        .catch((error) => dispatch(getEmailListAction.getEmailListFailure(error)));
    };
  },
  getEmailListPending: () => ({
    type: actionTypes.GET_EMAIL_LIST_PENDING,
  }),
  getEmailListFulfilled: (data) => ({
    type: actionTypes.GET_EMAIL_LIST_FULFILLED,
    data,
  }),
  getEmailListFailure: (error) => ({
    type: actionTypes.GET_EMAIL_LIST_FAILURE,
    error,
  }),
};

// get email draft
export const getEmailDraftAction = {
  getEmailDraft: (projectCode, draftSeq) => {
    return (dispatch) => {
      dispatch(getEmailDraftAction.getEmailDraftPending());
      API.getEmailDraft(projectCode, draftSeq)
        .then((res) => dispatch(getEmailDraftAction.getEmailDraftFulfilled(res)))
        .catch((error) => dispatch(getEmailDraftAction.getEmailDraftFailure(error)));
    };
  },
  getEmailDraftPending: () => ({
    type: actionTypes.GET_EMAIL_DRAFT_PEDNING,
  }),
  getEmailDraftFulfilled: (data) => ({
    type: actionTypes.GET_EMAIL_DRAFT_FULFILLED,
    data,
  }),
  getEmailDraftFailure: (error) => ({
    type: actionTypes.GET_EMAIL_DRAFT_FAILURE,
    error,
  }),
};

// post email list
export const postEmailListAction = {
  postEmailList: (projectCode, template) => {
    return (dispatch) => {
      const data = {
        sender: '',
        title: template.emailTitle,
        sendAt: null,
        uuids: [],
        senderEmail: DEFAULT_SENDER_EMAIL,
        replyTo: '',
        bcc: [],
        html: template.html,
        json: JSON.stringify(template.json),
        note: '',
        receiverType: RECEIVER_TYPE.none, // null, 0, 1, 2, 3
        type: EMAIL_TYPE.sketch,
      };

      dispatch(postEmailListAction.postEmailListPending());
      API.postEmailList(projectCode, data)
        .then((res) => dispatch(postEmailListAction.postEmailListFulfilled(res)))
        .catch((error) => dispatch(postEmailListAction.postEmailListFailure(error)));
    };
  },
  postEmailListPending: () => ({
    type: actionTypes.POST_EMAIL_LIST_PENDING,
  }),
  postEmailListFulfilled: (data) => ({
    type: actionTypes.POST_EMAIL_LIST_FULFILLED,
    data,
  }),
  postEmailListFailure: (error) => ({
    type: actionTypes.POST_EMAIL_LIST_FAILURE,
    error,
  }),
};

// delete email list
export const deleteEmailListAction = {
  deleteEmailList: (projectCode, seq) => {
    return (dispatch) => {
      dispatch(deleteEmailListAction.deleteEmailListPending());
      API.deleteEmailDraft(projectCode, seq)
        .then((res) => dispatch(deleteEmailListAction.deleteEmailListFulfilled(res)))
        .catch((error) => dispatch(deleteEmailListAction.deleteEmailListFailure(error)));
    };
  },
  deleteEmailListPending: () => ({
    type: actionTypes.DELETE_EMAIL_LIST_PENDING,
  }),
  deleteEmailListFulfilled: (data) => ({
    type: actionTypes.DELETE_EMAIL_LIST_FULFILLED,
    data,
  }),
  deleteEmailListFailure: (error) => ({
    type: actionTypes.DELETE_EMAIL_LIST_FAILURE,
    error,
  }),
};

// patch email list
export const patchEmailListAction = {
  patchEmailList: (projectCode, seq, data) => {
    return (dispatch) => {
      dispatch(patchEmailListAction.patchEmailListPending());
      API.patchEmailDraft(projectCode, seq, data)
        .then((res) => dispatch(patchEmailListAction.patchEmailListFulfilled(res)))
        .catch((error) => {
          dispatch(patchEmailListAction.patchEmailListFailure(error));
        });
    };
  },
  patchEmailListPending: () => ({
    type: actionTypes.PATCH_EMAIL_LIST_PENDING,
  }),
  patchEmailListFulfilled: (data) => ({
    type: actionTypes.PATCH_EMAIL_LIST_FULFILLED,
    data,
  }),
  patchEmailListFailure: (error) => ({
    type: actionTypes.PATCH_EMAIL_LIST_FAILURE,
    error,
  }),
};

// POST copy email list
export const postCopyEmailListAction = {
  postCopyEmailList: (projectCode, draftSeq) => {
    return (dispatch) => {
      dispatch(postCopyEmailListAction.postCopyEmailListPending());
      API.postCopyEmailList(projectCode, draftSeq)
        .then((res) => dispatch(postCopyEmailListAction.postCopyEmailListFulfilled(res)))
        .catch((error) => dispatch(postCopyEmailListAction.postCopyEmailListFailure(error)));
    };
  },
  postCopyEmailListPending: () => ({
    type: actionTypes.POST_COPY_EMAIL_LIST_PENDING,
  }),
  postCopyEmailListFulfilled: (data) => ({
    type: actionTypes.POST_COPY_EMAIL_LIST_FULFILLED,
    data,
  }),
  postCopyEmailListFailure: (error) => ({
    type: actionTypes.POST_COPY_EMAIL_LIST_FULFILLED,
    error,
  }),
};

// check email list 有無特定參加者
export const getParticularAttendeeNumberAction = {
  getParticularAttendeeNumber: (projectCode) => {
    return (dispatch) => {
      dispatch(getParticularAttendeeNumberAction.getParticularAttendeeNumberPending());
      API.getParticularAttendeeNumber(projectCode)
        .then((res) =>
          dispatch(getParticularAttendeeNumberAction.getParticularAttendeeNumberFulfilled(res)),
        )
        .catch((error) =>
          dispatch(getParticularAttendeeNumberAction.getParticularAttendeeNumberFailure(error)),
        );
    };
  },
  getParticularAttendeeNumberPending: () => ({
    type: actionTypes.GET_PARTICULAR_ATTENDEE_NUMBER_PENDING,
  }),
  getParticularAttendeeNumberFulfilled: (data) => ({
    type: actionTypes.GET_PARTICULAR_ATTENDEE_NUMBER_FULFILLED,
    data,
  }),
  getParticularAttendeeNumberFailure: (error) => ({
    type: actionTypes.GET_PARTICULAR_ATTENDEE_NUMBER_FAILURE,
    error,
  }),
};

// get email preview
export const getEmailPreviewAction = {
  getEmailPreview: (projectCode, draftSeq) => {
    return (dispatch) => {
      dispatch(getEmailPreviewAction.getEmailPreviewPending());
      API.getEmailPreview(projectCode, draftSeq)
        .then((res) => dispatch(getEmailPreviewAction.getEmailPreviewFulfilled(res)))
        .catch((error) => dispatch(getEmailPreviewAction.getEmailPreviewFailure(error)));
    };
  },
  getEmailPreviewPending: () => ({
    type: actionTypes.GET_EMAIL_PREVIEW_PENDING,
  }),
  getEmailPreviewFulfilled: (data) => ({
    type: actionTypes.GET_EMAIL_PREVIEW_FULFILLED,
    data,
  }),
  getEmailPreviewFailure: (error) => ({
    type: actionTypes.GET_EMAIL_PREVIEW_FAILURE,
    error,
  }),
};

// ----- email record -------
// GET single email record
export const getSingleEmailRecordAction = {
  getSingleEmailRecord: (projectCode, draftSeq) => {
    return (dispatch) => {
      dispatch(getSingleEmailRecordAction.getSingleEmailRecordPending());
      API.getSingleEmailRecord(projectCode, draftSeq)
        .then((res) => dispatch(getSingleEmailRecordAction.getSingleEmailRecordFulfilled(res)))
        .catch((error) => dispatch(getSingleEmailRecordAction.getSingleEmailRecordFailure(error)));
    };
  },
  getSingleEmailRecordPending: () => ({
    type: actionTypes.GET_SINGLE_EMAIL_RECORD_PENDING,
  }),
  getSingleEmailRecordFulfilled: (data) => ({
    type: actionTypes.GET_SINGLE_EMAIL_RECORD_FULFILLED,
    data,
  }),
  getSingleEmailRecordFailure: (error) => ({
    type: actionTypes.GET_SINGLE_EMAIL_RECORD_FAILURE,
    error,
  }),
};

// -------- SMS -----------
// get sms list
export const getSmsListAction = {
  getSmsList: (proejctCode) => {
    return (dispatch) => {
      dispatch(getSmsListAction.getSmsListPending());
      API.getSmsList(proejctCode)
        .then((res) => dispatch(getSmsListAction.getSmsListFulfilled(res)))
        .catch((error) => dispatch(getSmsListAction.getSmsListFailure(error)));
    };
  },

  getSmsListPending: () => ({
    type: actionTypes.GET_SMS_LIST_PENDING,
  }),
  getSmsListFulfilled: (data) => ({
    type: actionTypes.GET_SMS_LIST_FULFILLED,
    data,
  }),
  getSmsListFailure: (error) => ({
    type: actionTypes.GET_SMS_LIST_FAILURE,
    error,
  }),
};

export const getSmsDraftAction = {
  getSmsDraft: (projectCode, draftSeq) => {
    return (dispatch) => {
      dispatch(getSmsDraftAction.getSmsDraftPending());
      API.getSmsDraft(projectCode, draftSeq)
        .then((res) => dispatch(getSmsDraftAction.getSmsDraftFulfilled(res)))
        .catch((error) => dispatch(getSmsDraftAction.getSmsDraftFailure(error)));
    };
  },
  getSmsDraftPending: () => ({
    type: actionTypes.GET_SMS_DRAFT_PENDING,
  }),
  getSmsDraftFulfilled: (data) => ({
    type: actionTypes.GET_SMS_DRAFT_FULFILLED,
    data,
  }),
  getSmsDraftFailure: (error) => ({
    type: actionTypes.GET_SMS_DRAFT_FAILURE,
    error,
  }),
};

export const postSmsDraftAction = {
  postSmsDraft: (projectCode, data) => {
    return (dispatch) => {
      dispatch(postSmsDraftAction.postSmsDraftPending());
      API.postSmsDraft(projectCode, data)
        .then((res) => dispatch(postSmsDraftAction.postSmsDraftFulfilled(res)))
        .catch((error) => dispatch(postSmsDraftAction.postSmsDraftFailure(error)));
    };
  },
  postSmsDraftPending: () => ({
    type: actionTypes.POST_SMS_DRAFT_PENDING,
  }),
  postSmsDraftFulfilled: (data) => ({
    type: actionTypes.POST_SMS_DRAFT_FULFILLED,
    data,
  }),
  postSmsDraftFailure: (error) => ({
    type: actionTypes.POST_SMS_DRAFT_FAILURE,
    error,
  }),
};

export const patchSmsDraftAction = {
  patchSmsDraft: (projectCode, draftSeq, data) => {
    return (dispatch) => {
      dispatch(patchSmsDraftAction.patchSmsDraftPending());
      API.patchSmsDraft(projectCode, draftSeq, data)
        .then((res) => dispatch(patchSmsDraftAction.patchSmsDraftFulfilled(res)))
        .catch((error) => dispatch(patchSmsDraftAction.patchSmsDraftFailure(error)));
    };
  },
  patchSmsDraftPending: () => ({
    type: actionTypes.PATCH_SMS_DRAFT_PENDING,
  }),
  patchSmsDraftFulfilled: (data) => ({
    type: actionTypes.PATCH_SMS_DRAFT_FULFILLED,
    data,
  }),
  patchSmsDraftFailure: (error) => ({
    type: actionTypes.PATCH_SMS_DRAFT_FAILURE,
    error,
  }),
};

export const deleteSmsDraftAction = {
  deleteSmsDraft: (projectCode, draftSeq) => {
    return (dispatch) => {
      dispatch(deleteSmsDraftAction.deleteSmsDraftPending());
      API.deleteSmsDraft(projectCode, draftSeq)
        .then((res) => dispatch(deleteSmsDraftAction.deleteSmsDraftFulfilled(res)))
        .catch((error) => dispatch(deleteSmsDraftAction.deleteSmsDraftFailure(error)));
    };
  },
  deleteSmsDraftPending: () => ({
    type: actionTypes.DELETE_SMS_DRAFT_PEDNING,
  }),
  deleteSmsDraftFulfilled: (data) => ({
    type: actionTypes.DELETE_SMS_DRAFT_FULFILLED,
    data,
  }),
  deleteSmsDraftFailure: (error) => ({
    type: actionTypes.DELETE_SMS_DRAFT_FAILURE,
    error,
  }),
};

export const postCopySmsDraftAction = {
  postCopySmsDraft: (projectCode, draftSeq) => {
    return (dispatch) => {
      dispatch(postCopySmsDraftAction.postCopySmsDraftPending());
      API.postCopySmsDraft(projectCode, draftSeq)
        .then((res) => dispatch(postCopySmsDraftAction.postCopySmsDraftFulfilled(res)))
        .catch((error) => dispatch(postCopySmsDraftAction.postCopySmsDraftFailure(error)));
    };
  },
  postCopySmsDraftPending: () => ({
    type: actionTypes.POST_COPY_SMS_DRAFT_PENDING,
  }),
  postCopySmsDraftFulfilled: (data) => ({
    type: actionTypes.POST_COPY_SMS_DRAFT_FULFILLED,
    data,
  }),
  postCopySmsDraftFailure: (error) => ({
    type: actionTypes.POST_COPY_SMS_DRAFT_FAILURE,
    error,
  }),
};

export const getSingleSmsRecordAction = {
  getSingleSmsRecord: (projectCode, draftSeq) => {
    return (dispatch) => {
      dispatch(getSingleSmsRecordAction.getSingleSmsRecordPending());
      API.getSingleSmsRecord(projectCode, draftSeq)
        .then((res) => dispatch(getSingleSmsRecordAction.getSingleSmsRecordFulfilled(res)))
        .catch((error) => dispatch(getSingleSmsRecordAction.getSingleSmsRecordFailure(error)));
    };
  },
  getSingleSmsRecordPending: () => ({
    type: actionTypes.GET_SINGLE_SMS_RECORD_PENDING,
  }),
  getSingleSmsRecordFulfilled: (data) => ({
    type: actionTypes.GET_SINGLE_SMS_RECORD_FULFILLED,
    data,
  }),
  getSingleSmsRecordFailure: (error) => ({
    type: actionTypes.GET_SINGLE_SMS_RECORD_FAILURE,
    error,
  }),
};

// get sms list preview
export const getSmsPreviewAction = {
  getSmsPreview: (projectCode, draftSeq) => {
    return (dispatch) => {
      dispatch(getSmsPreviewAction.getSmsPreviewPending());
      API.getSmsPreview(projectCode, draftSeq)
        .then((res) => dispatch(getSmsPreviewAction.getSmsPreviewFulfilled(res)))
        .catch((error) => dispatch(getSmsPreviewAction.getSmsPreviewFaiure(error)));
    };
  },
  getSmsPreviewPending: () => ({
    type: actionTypes.GET_SMS_PREVIEW_PENDING,
  }),
  getSmsPreviewFulfilled: (data) => ({
    type: actionTypes.GET_SMS_PREVIEW_FULFILLED,
    data,
  }),
  getSmsPreviewFailure: (error) => ({
    type: actionTypes.GET_SMS_PREVIEW_FAILURE,
    error,
  }),
};

// ---------- Health Form -----------
// GET helath form templates
export const getHealthFormTemplatesPending = () => ({
  type: actionTypes.GET_HEALTH_FORM_TEMPLATES_PENDING,
});
export const getHealthFormTemplatesFulfilled = (data) => ({
  type: actionTypes.GET_HEALTH_FORM_TEMPLATES_FULFILLED,
  data,
});
export const getHealthFormTemplatesFailure = (error) => ({
  type: actionTypes.GET_HEALTH_FORM_TEMPLATES_FAILURE,
  error,
});
export const getHealthFormTemplates = () => {
  return (dispatch) => {
    dispatch(getHealthFormTemplatesPending());
    API.getHealthFormTemplates()
      .then((res) => dispatch(getHealthFormTemplatesFulfilled(res)))
      .catch((error) => dispatch(getHealthFormTemplatesFailure(error)));
  };
};

// GET event health form setting
export const getHealthFormSettingPending = () => ({
  type: actionTypes.GET_HEALTH_FORM_SETTING_PENDING,
});
export const getHealthFormSettingFulfilled = (data) => ({
  type: actionTypes.GET_HEALTH_FORM_SETTING_FULFILLED,
  data,
});
export const getHealthFormSettingFailure = (error) => ({
  type: actionTypes.GET_HEALTH_FORM_SETTING_FAILURE,
  error,
});
export const getHelathFormSetting = (projectId) => {
  return (dispatch) => {
    dispatch(getHealthFormSettingPending());
    API.getHealthFormSetting(projectId)
      .then((res) => dispatch(getHealthFormSettingFulfilled(res)))
      .catch((error) => dispatch(getHealthFormSettingFailure(error)));
  };
};

// PATCH event health form setting
export const patchHealthFormSettingPending = () => ({
  type: actionTypes.PATCH_HEALTH_FORM_SETTING_PENDING,
});
export const patchHealthFormSettingFulfilled = (data) => ({
  type: actionTypes.PATCH_HEALTH_FORM_SETTING_FULFILLED,
  data,
});
export const patchHealthFormSettingFailure = (error) => ({
  type: actionTypes.PATCH_HEALTH_FORM_SETTING_FAILURE,
  error,
});
export const patchHealthFormSetting = (projectId, data) => {
  return (dispatch) => {
    dispatch(patchHealthFormSettingPending());
    API.patchHealthFormSetting(projectId, data)
      .then((res) => dispatch(patchHealthFormSettingFulfilled(res)))
      .catch((error) => dispatch(patchHealthFormSettingFailure(error)));
  };
};

// 報到人數限額
export const setCheckInQuota = (data) => ({
  type: actionTypes.SET_CHECKIN_QUOTA,
  data,
});

// ----- point -----
export const setTotalPoint = (data) => ({
  type: actionTypes.SET_TOTAL_POINT,
  data,
});

// 取得實際扣點數字
export const postContentToGetRealCostPending = () => ({
  type: actionTypes.POST_CONTENT_TO_GET_REAL_COST_PENDING,
});
export const postContentToGetRealCostFulfilled = (data) => ({
  type: actionTypes.POST_CONTENT_TO_GET_REAL_COST_FULFILLED,
  data,
});
export const postContentToGetRealCostFailure = (error) => ({
  type: actionTypes.POST_CONTENT_TO_GET_REAL_COST_FAILURE,
  error,
});
export const postContentToGetRealCost = (projectCode, data) => {
  return (dispatch) => {
    dispatch(postContentToGetRealCostPending());
    API.postContentToGetRealCost(projectCode, data)
      .then((res) => dispatch(postContentToGetRealCostFulfilled(res)))
      .catch((error) => dispatch(postContentToGetRealCostFailure(error)));
  };
};

// ------- FILE ----------
export const postFileUploadAction = {
  postFileUpload: (file) => {
    return (dispatch) => {
      dispatch(postFileUploadAction.postFileUploadPending());
      API.postFileUpload(file)
        .then((res) => dispatch(postFileUploadAction.postFileUploadFulfilled(res)))
        .catch((error) => dispatch(postFileUploadAction.postFileUploadFailure(error)));
    };
  },
  postFileUploadPending: () => ({
    type: actionTypes.POST_FILE_UPLOAD_PENDING,
  }),
  postFileUploadFulfilled: (data) => ({
    type: actionTypes.POST_FILE_UPLOAD_FULFILLED,
    data,
  }),
  postFileUploadFailure: (error) => ({
    type: actionTypes.POST_FILE_UPLOAD_FAILURE,
    error,
  }),
};

// -------- index page -------------
// GET index page setting data
export const getIndexPageEditPending = () => ({
  type: actionTypes.GET_INDEX_PAGE_EDIT_PENDING,
});
export const getIndexPageEditFulfilled = (data) => ({
  type: actionTypes.GET_INDEX_PAGE_EDIT_FULFILLED,
  data,
});
export const getIndexPageEditFailure = (error) => ({
  type: actionTypes.GET_INDEX_PAGE_EDIT_FAILURE,
  error,
});
// 變換語系或變換活動時皆會由此拿到專屬頁面設定
export const getIndexPageEdit = (projectCode, lang) => {
  return (dispatch) => {
    dispatch(getIndexPageEditPending());
    API.getIndexPageEdit(projectCode, lang)
      .then((res) => dispatch(getIndexPageEditFulfilled(res)))
      .catch((error) => dispatch(getIndexPageEditFailure(error)));
  };
};

// add a index page
export const postIndexPagePending = () => ({
  type: actionTypes.POST_INDEX_PAGE_PENDING,
});
export const postIndexPageFulfilled = (data) => ({
  type: actionTypes.POST_INDEX_PAGE_FULFILLED,
  data,
});
export const postIndexPageFailure = (error) => ({
  type: actionTypes.POST_INDEX_PAGE_FAILURE,
  error,
});
export const postIndexPage = (projectId, data) => {
  return (dispatch) => {
    dispatch(postIndexPagePending());
    API.postIndexPage(projectId, data)
      .then((res) => dispatch(postIndexPageFulfilled(res)))
      .catch((error) => dispatch(postIndexPageFailure(error)));
  };
};

// PATCH index page setting data
export const patchIndexPageEditPending = () => ({
  type: actionTypes.PATCH_INDEX_PAGE_EDIT_PENDING,
});
export const patchIndexPageEditFulfilled = (data) => ({
  type: actionTypes.PATCH_INDEX_PAGE_EDIT_FULFILLED,
  data,
});
export const patchIndexPageEditFailure = (error) => ({
  type: actionTypes.PATCH_INDEX_PAGE_EDIT_FAILURE,
  error,
});
export const patchIndexPageEdit = (uuid, data) => {
  return (dispatch) => {
    dispatch(patchIndexPageEditPending());
    API.patchIndexPageEdit(uuid, data)
      .then((res) => dispatch(patchIndexPageEditFulfilled(res)))
      .catch((error) => dispatch(patchIndexPageEditFailure(error)));
  };
};

// GET guest index page
export const getGuestIndexPagePending = () => ({
  type: actionTypes.GET_GUEST_INDEX_PAGE_PENDING,
});
export const getGuestIndexPageFulfilled = (data) => ({
  type: actionTypes.GET_GUEST_INDEX_PAGE_FULFILLED,
  data,
});
export const getGuestIndexPageFailure = (error) => ({
  type: actionTypes.GET_GUEST_INDEX_PAGE_FAILURE,
  error,
});
export const getGuestIndexPage = (projectCode, userCode, preview) => {
  return (dispatch) => {
    dispatch(getGuestIndexPagePending());
    API.getGuestIndexPage(projectCode, userCode, preview)
      .then((res) => dispatch(getGuestIndexPageFulfilled(res)))
      .catch((error) => dispatch(getGuestIndexPageFailure(error)));
  };
};

// get index page preview data
export const getIndexPagePreviewPending = () => ({
  type: actionTypes.GET_INDEX_PAGE_PREVIEW_PENDING,
});
export const getIndexPagePreviewFulfilled = (data) => ({
  type: actionTypes.GET_INDEX_PAGE_PREVIEW_FULFILLED,
  data,
});
export const getIndexPagePreviewFailure = (error) => ({
  type: actionTypes.GET_INDEX_PAGE_PREVIEW_FAILURE,
  error,
});
export const getIndexPagePreview = (projectCode, userId) => {
  return (dispatch) => {
    dispatch(getIndexPagePreviewPending());
    API.getIndexPagePreview(projectCode, userId)
      .then((res) => dispatch(getIndexPagePreviewFulfilled(res)))
      .catch((error) => dispatch(getIndexPagePreviewFailure(error)));
  };
};

//  ------- statistic ------------
export const getAttendeeCheckinSituationAction = {
  getAttendeeCheckinSituation: (projectId) => {
    return (dispatch) => {
      dispatch(getAttendeeCheckinSituationAction.getAttendeeCheckinSituationPending());
      API.getAttendeeCheckinSituation(projectId)
        .then((res) =>
          dispatch(getAttendeeCheckinSituationAction.getAttendeeCheckinSituationFulfilled(res)),
        )
        .catch((error) =>
          dispatch(getAttendeeCheckinSituationAction.getAttendeeCheckinSituationFailure(error)),
        );
    };
  },
  getAttendeeCheckinSituationPending: () => ({
    type: actionTypes.GET_ATTENDEE_CHECKIN_SITUATION_PENDING,
  }),
  getAttendeeCheckinSituationFulfilled: (data) => ({
    type: actionTypes.GET_ATTENDEE_CHECKIN_SITUATION_FULFILLED,
    data,
  }),
  getAttendeeCheckinSituationFailure: (error) => ({
    type: actionTypes.GET_ATTENDEE_CHECKIN_SITUATION_FAILURE,
    error,
  }),
};

// 匯出統計報表
export const postExportStatisticCheckinReportAction = {
  postExportStatisticCheckinReport: (projectId) => {
    return (dispatch) => {
      dispatch(postExportStatisticCheckinReportAction.postExportStatisticCheckinReportPending());
      API.postExportStatisticCheckinReport(projectId)
        .then((res) =>
          dispatch(
            postExportStatisticCheckinReportAction.postExportStatisticCheckinReportFulfilled(res),
          ),
        )
        .catch((error) =>
          dispatch(
            postExportStatisticCheckinReportAction.postExportStatisticCheckinReportFailure(error),
          ),
        );
    };
  },
  postExportStatisticCheckinReportPending: () => ({
    type: actionTypes.POST_EXPORT_STATISTIC_CHECKIN_REPORT_PENDING,
  }),
  postExportStatisticCheckinReportFulfilled: (data) => ({
    type: actionTypes.POST_EXPORT_STATISTIC_CHECKIN_REPORT_FULFILLED,
    data,
  }),
  postExportStatisticCheckinReportFailure: (error) => ({
    type: actionTypes.POST_EXPORT_STATISTIC_CHECKIN_REPORT_FAILURE,
    error,
  }),
};

// 取得自訂圖表 list
export const getCustomizeChartListAction = {
  getCustomizeChartList: (tokenId, projectId) => {
    return (dispatch) => {
      dispatch(getCustomizeChartListAction.getCustomizeChartListPending());
      API.getCustomizeChartList(tokenId, projectId)
        .then((res) => dispatch(getCustomizeChartListAction.getCustomizeChartListFulfilled(res)))
        .catch((error) =>
          dispatch(getCustomizeChartListAction.getCustomizeChartListFailure(error)),
        );
    };
  },
  getCustomizeChartListPending: () => ({
    type: actionTypes.GET_CUSTOMIZE_CHART_LIST_PENDING,
  }),
  getCustomizeChartListFulfilled: (data) => ({
    type: actionTypes.GET_CUSTOMIZE_CHART_LIST_FULFILLED,
    data,
  }),
  getCustomizeChartListFailure: (error) => ({
    type: actionTypes.GET_CUSTOMIZE_CHART_LIST_FAILURE,
    error,
  }),
};

// post single 自訂圖表
export const postSingleCustomizeChartAction = {
  postSingleCustomizeChart: (tokenId, projectId, data) => {
    return (dispatch) => {
      dispatch(postSingleCustomizeChartAction.postSingleCustomizeChartPending());
      API.postSingleCustomizeChart(tokenId, projectId, data)
        .then((res) =>
          dispatch(postSingleCustomizeChartAction.postSingleCustomizeChartFulfilled(res)),
        )
        .catch((error) =>
          dispatch(postSingleCustomizeChartAction.postSingleCustomizeChartFailure(error)),
        );
    };
  },
  postSingleCustomizeChartPending: () => ({
    type: actionTypes.POST_SINGLE_CUSTOMIZE_CHART_PENDING,
  }),
  postSingleCustomizeChartFulfilled: (data) => ({
    type: actionTypes.POST_SINGLE_CUSTOMIZE_CHART_FULFILLED,
    data,
  }),
  postSingleCustomizeChartFailure: (error) => ({
    type: actionTypes.POST_SINGLE_CUSTOMIZE_CHART_FAILURE,
    error,
  }),
};

// delete single customize chart
export const deleteSingleCustomizeChartAction = {
  deleteSingleCustomizeChart: (tokenId, projectId, seq) => {
    return (dispatch) => {
      dispatch(deleteSingleCustomizeChartAction.deleteSingleCustomizeChartPending());
      API.deleteSingleCustomizeChart(tokenId, projectId, seq)
        .then((res) =>
          dispatch(deleteSingleCustomizeChartAction.deleteSingleCustomizeChartFulfilled(res)),
        )
        .catch((error) =>
          dispatch(deleteSingleCustomizeChartAction.deleteSingleCustomizeChartFailure(error)),
        );
    };
  },
  deleteSingleCustomizeChartPending: () => ({
    type: actionTypes.DELETE_SINGLE_CUSTOMIZE_CHART_PENDING,
  }),
  deleteSingleCustomizeChartFulfilled: (data) => ({
    type: actionTypes.DELETE_SINGLE_CUSTOMIZE_CHART_FULFILLED,
    data,
  }),
  deleteSingleCustomizeChartFailure: (error) => ({
    type: actionTypes.DELETE_SINGLE_CUSTOMIZE_CHART_FAILURE,
    error,
  }),
};
